import { createCustomEnum } from "./customEnum";

const TsysFileTypes = createCustomEnum({
	None: {
		value: 0,
		name: "None",
		displayName: "None",
	},
	Sierra: {
		value: 1,
		name: "Sierra",
		displayName: "Sierra (Stage Only)",
	},
	Summit: {
		value: 2,
		name: "Summit",
		displayName: "Summit",
	},
	TransIT: {
		value: 3,
		name: "TransIT",
		displayName: "TransIT",
	},
	Other: {
		value: 4,
		name: "Other",
		displayName: "Other",
	},
});

export default TsysFileTypes;
